export default __webpack_public_path__ + "static/media/holy.deef7882.svg";